import { render } from "./CommonGrid.vue?vue&type=template&id=e458d796"
import script from "./CommonGrid.vue?vue&type=script&lang=js"
export * from "./CommonGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__